<div class="question-stepper">
  <div class="question-stepper__img">
    <img [src]="stepperIconImage" class="icon">
  </div>
  <div class="question-stepper__content">
    <h3 class="font-normal" [innerHTML]="question.question_copy"></h3>
    <p><a href="javascript:;" (click)="onSkipStepClick()">Skip {{stepperContentType}}</a></p>
  </div>
</div>
